import { useTranslation } from "react-i18next";
import { FormInput } from "../../../../components/FormInput";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { Dropdown } from "primereact/dropdown";
import { FormInputFile } from "../../../../components/FormInputFile";

export const AddTransportation =({ 
    register, errors, control, setValue,
    fileInputRef,
})=>{
    const { t } = useTranslation();
    const handleFileChange = (e) => {}

    return(
        <form className="grid">
            <div className="col-12 lg:col-7">
                <FormInput
                    register={register}
                    errors={errors}
                    id="address"
                    name="address"
                    type="text"
                    labelText="項目/配銷地址"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-3">
                <FormInput
                    register={register}
                    errors={errors}
                    id="total"
                    name="total"
                    type="number"
                    labelText="數值/配銷總數量"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">{t('unit')}</label>
                <Controller
                    name="itemsUnit"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="itemsUnit"
                            control={control}
                            options={[{label:'包',value:0},{label:'箱',value:1},{label:'公斤',value:2},{label:'公噸',value:3}]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12 lg:col-5">
                <FormInput
                    register={register}
                    errors={errors}
                    id="TransportationStarting"
                    name="TransportationStarting"
                    type="text"
                    labelText="運輸起點"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">運輸方式</label>
                <Controller
                    name="transportation"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="transportation"
                            control={control}
                            options={[{label:'運輸卡車',value:0},{label:'飛機',value:1},{label:'貨輪',value:2}]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12 lg:col-3">
                <FormInput
                    register={register}
                    errors={errors}
                    id="transportationValue"
                    name="transportationValue"
                    type="text"
                    labelText="單趟運輸距離"
                    labelClass="required"
                />
            </div>
            <div className="col-12 lg:col-2">
                <label htmlFor="" className="required form-label">{t('unit')}</label>
                <Controller
                    name="transportationUnit"
                    control={control}
                    // rules={{ required: { value: true, message: t('validation.required') } }}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            // appendTo={"self"}
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            // virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="transportationUnit"
                            control={control}
                            options={[{label:'公尺(m)',value:'m'},{label:'公里(km)',value:'km'},{label:'海哩(um)',value:'um'}]}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                                // setValue(`addressItems.${index}.zipcodeSeq`, "")
                            }}
                        />
                    )} />
            </div>
            <div className="col-12">
                <FormInput
                    register={register}
                    errors={errors}
                    id="remark"
                    name="remark"
                    type="text"
                    labelText={t('remark')}
                />
            </div>
             {/* 附圖/附件 */}
             <div className='col-12'>
                <label
                    htmlFor="customFile"
                    className="form-label">
                    {`${t('attached_picture')}/${t('attachments')}`}
                </label>

                <FormInputFile
                    register={register}
                    errors={errors}
                    acceptFileType=".jpg,.png,.pdf"
                    id="customFile"
                    name="customFile"
                    limitSize="20MB"
                    fileChange={(e) => { handleFileChange(e) }}
                    fileInputRef={fileInputRef}
                />

                {/* {
                    getValues("fileExtension") !== 'zip' && (
                        <ImagePDFComponent
                            wrapperClass='mt-2'
                            file={fileInfo}
                            previewUrl={previewUrl}
                            zoomSrc={zoomSrc}
                            disabled={false}
                            deleteImg={handleDeleteImg}
                        />
                    )
                } */}

                {/* {
                    (watch("fileExtension") === 'zip') && (
                        <div className="flex flex-wrap lg:flex-nowrap align-items-center">
                            <label>{watch("fileName")}{watch("fileName") !== '' ? '.' : ''}{watch("fileExtension")}</label>
                            <Button
                                type='button'
                                icon="pi pi-trash"
                                tooltip={t('button.delete')} tooltipOptions={{ position: 'top' }}
                                className='p-button-icon-only' rounded text
                                severity="danger"
                                onClick={(e) => { handleDeleteImg(e) }}>
                            </Button>

                            <Button rounded text severity="secondary"
                                className="p-button-icon-only" type="button"
                                tooltip={t('button.download')} tooltipOptions={{ position: 'top' }}
                                onClick={() => { downloadItem(cusObj) }}>
                                <FontAwesomeIcon icon="fa-solid fa-cloud-arrow-down" />
                            </Button>
                        </div>
                    )
                } */}

            </div>
        </form>
    )
}